import { Transform } from '4d-mapper';
import { CoordGeodetic } from '../../../service/coord-helper.service';
import { FdmPlugin, FdmBucketPlugin, FdmPluginInterface } from '../plugins';

const Cesium = (<any>window).Cesium;

export class PerimeterHandler extends FdmBucketPlugin implements FdmPluginInterface {

    debug:boolean = false;

    // required name identifier
    static meta = {
        label: 'PLUGINS.PERIMETER_HANDLER.LABEL',
        name: 'perimeter-handler',
        translator: 'PLUGINS.PERIMETER_HANDLER',
        tooltip: 'PLUGINS.PERIMETER_HANDLER.TOOLTIP',

        category: FdmPlugin.category.generic,
        cardinality: FdmPlugin.cardinality.one,
        // types: [ FdmPlugin.types.sceneController ]
    };

    items:any = {};

    tilesets:any = {};

    selected:any = null;
    oldSelected:any = null;

    screenSpaceEventHandler:any = null;
    screenTick:number = 0;

    mapService:any = null;
    measureHelper:any = null;
    coordHelper:any = null;

    init() {

        this.mapService = this.services.mapService;
        this.measureHelper = this.services.measureHelper;
        this.coordHelper = this.services.coordHelper;

        if ( this.debug ) { console.log ( '##### PERIMETER INIT' ); }
        this.screenSpaceEventHandler = new Cesium.ScreenSpaceEventHandler(this.mapService.viewer.scene.canvas);

        this.mapService.viewer.scene.preRender.addEventListener((info) => {

            if ( this.screenTick++ > 4 ) {
                this.screenTick = 0;

                if ( this.measureHelper.pickedModel ) {

                    // console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ pickModel', this.measureHelper.pickedModel );

                    if ( this.selected !== this.measureHelper.pickedModel['primitive'] ) {

                        if ( this.selected ) {
                            this.turnOff(this.selected);
                        }

                        this.selected = this.measureHelper.pickedModel['primitive'];
                        this.turnOn (this.selected);

                    } 
                } else {
                    if ( this.selected ) {
                        this.turnOff(this.selected);
                        this.selected = null;
                    }
                }
                
            };

        });
    }

    turn ( t:any, onoff:boolean = true ) {

        let id = t['transform_id'];
        if ( id ) {
            let tb = this.entity( 'tb_'+id );
            let tf = this.entity( 'tf_'+id );
    
            if ( this.debug ) { console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', t, id, onoff, tb, tf ); }
    
            if ( tb ) {
                tb.show = onoff;
            }
            if ( tf ) {
                tf.show = onoff;
            }
        }
        
    }

    turnOn(t:any) {
        this.turn ( t, true );
    }
    
    turnOff(t:any) {
        this.turn ( t, false );
    }

    inTheMomentProps ( p ) {
        
        let t = typeof p;
        let c = null; // p.constructor.name;
        if ( p && p.constructor ) {
            c = p.constructor.name;
        }
        let props = null;
        if ( p && t == 'object' ) {
            props = Object.keys(p).join(',');
        }
        let f = {
            __type: t, __class: c, __props: props
        };
        if ( props ) {
            Object.keys(p).forEach ( key => {
                let x = p[key];
                if ( x ) { f[key] = x; }
            });
        }
        return f; // console.log ( ' ----------- ', t, c, f );
    }

    expandPositions ( inp:any ) {
        let positions = [];
        let n = 0;
        inp.forEach ( i => {

            n++;

            let pos = i.pos;
            let rad = i.rad;

            if ( this.debug ) { 
                this.entity( 'sphere_'+n, this.mapService.viewer.entities.add({
                    position: pos,
                    ellipsoid: {
                        radii: new Cesium.Cartesian3 ( rad, rad, rad ),
                        material: Cesium.Color.WHITE.withAlpha(0.0001),
                        outline: true,
                        outlineColor: Cesium.Color.YELLOW.withAlpha(0.2),
                        slicePartitions: 3,
                        stackPartitions: 5,
                    }
                }));
                this.entity( 'dot_'+n, this.mapService.viewer.entities.add({
                    position: pos,
                    point: {
                        pixelSize: 20,
                        color: Cesium.Color.YELLOW,
                        heightReference : Cesium.HeightReference.CLAMP_TO_GROUND
                    },
                    label: {
                        text: ''+rad+'m',
                        font : '12px sans-serif',
                    }
                }));
            }

            const log = Math.log ( rad );

            let rnd_t = Math.floor(Math.random() * 5) + 8 ;
            let rnd_s = Math.floor(Math.random() * 30) + 5 ;

            let times = rnd_t - Math.round ( log ); // Math.round ( ( 33 / rad ) * ( 200 / ( rad / 2 ) ) ); 
            let size = 6;

            if ( i.times ) {
                times = i.times;
            }
            if ( times > 1 ) {
                // const times = 12 - Math.round ( log );
                
                size = 5 + Math.round ( ( rad * 3 ) / log ); //  - Math.round ( rad / times );
                if ( i.size ) {
                    size = i.size;
                }
                size = rad / 1.3;
                const geodetic = new CoordGeodetic(pos);
                const scatter = this.coordHelper.getBoundingCoords ( geodetic, size, times );
                const cartesians = this.coordHelper.toCartesians(scatter);
                cartesians.forEach( c => { 
                    positions.push(c);
                    if ( this.debug ) { this.entity( 'zzt_'+n, this.mapService.viewer.entities.add({
                        position: c,
                        point: {
                            pixelSize: 15,
                            color: Cesium.Color.WHITE,
                            heightReference : Cesium.HeightReference.CLAMP_TO_GROUND
                        }
                    })); }
                });
            }
            if ( this.debug ) { console.log ( '@', n, times, rnd_t, size, rnd_s, rad ); }
        });
        if ( this.debug ) { console.log ( '**', inp.length, positions.length ); }
        return positions;
    }

    add ( t:Transform, obj:any = null, positions:any[] = null ) {

        let entity = obj.object;
        let me = this;

        this.items[t.id] = { 
            tid:t.id, 
            verticalOffset: t['vertical_offset'] ? t['vertical_offset'] : 0,
            centerPosition: null,
            centerRadius: null
        };

        if ( obj.boundingSphere ) {
            this.items[t.id].centerPosition = obj.boundingSphere.center;
            this.items[t.id].centerRadius = obj.boundingSphere.radius;
        }

        console.log ( '##### PERIMETER ADD ['+t.id+']['+t.name+']', t, obj, positions );

        if ( ! positions ) {
            if ( entity._root ) {
                let props = me.inTheMomentProps(entity._root);
                this.tilesets['t_'+t.id] = { __meta:'For '+t.id };
                let info = this.traverseTiles ( t.id, entity._root );
                if ( this.items[t.id].centerPosition ) {
                    info.push({ pos:this.items[t.id].centerPosition, rad:this.items[t.id].centerRadius });
                }
                let rawPositions = this.expandPositions(info); // info.map ( i => i.pos );
                positions = this.coordHelper.createHullCartesian3 ( rawPositions );
                if ( this.items[t.id].verticalOffset ) {
                    positions = this.coordHelper.updateCesiumCartesianHeights(positions, this.items[t.id].verticalOffset, true );
                }

                if ( this.debug ) { 
                    positions.forEach ( p => {
                        this.entity( 'zzt', this.mapService.viewer.entities.add({
                            position: p,
                            point: {
                                pixelSize: 25,
                                color: Cesium.Color.RED.withAlpha(0.8),
                                heightReference : Cesium.HeightReference.CLAMP_TO_GROUND
                            }
                        }));
                    });
                    console.log( '##### PERIMETER ADD TRAVERSE', rawPositions.length, positions.length, props, info );
                }
            }
        } else {
            let info = [];
            if ( this.debug ) { console.log( '##### STATIC POSITIONS START', positions ); }
            positions.forEach ( p => {
                info.push({
                    pos: p,
                    rad: 60,
                    times:5
                });
            });
            let rawPositions = this.expandPositions(info);
            positions = this.coordHelper.createHullCartesian3 ( rawPositions );
            if ( this.debug ) { console.log( '##### STATIC POSITIONS END', rawPositions.length, positions.length, info ); }
        }

        if ( positions ) {
            // create a loop
            positions.push(positions[0]);
            if ( this.debug ) { console.log ( '@@@ positions', positions ); }
            this.renderPositions ( t, positions );
        } else {
            if ( this.debug ) { console.log ( '@@@ NO positions', positions ); }
        }

        /* if ( entity['readyPromise'] ) {
            entity.readyPromise.then(function(tileset) {
                tileset.tileLoad.addEventListener(function(tile) {
                    // console.log('Tile loaded', me.inTheMomentProps(tile), tile );
                    let tid = t.id;
                    let uuid = tile.__uuid;
                    if ( me.tilesets['t_'+tid][uuid] ) {
                        me.checkTile(t.id,tile);
                        console.log('Tile loaded %c *FOUND* ['+tid+','+uuid+']', Constants._orange, me.tilesets['t_'+tid][uuid], tile );
                    } else {
                        console.log('Tile loaded not found ['+tid+','+uuid+']', me.tilesets, me.inTheMomentProps(tile) );
                    }
                });
            });
        } */
    }

    renderPositions ( t:any, positions:any[] = [] ) {
        let inc = 1;
        if ( this.debug ) { 
            this.entity( 'tx_'+t.id, this.mapService.viewer.entities.add({
                show:true,
                polyline: {
                    positions: positions,
                    width: 3.0,
                    heightReference : Cesium.HeightReference.CLAMP_TO_GROUND,
                    clampToGround : true,
                    material: Cesium.Color.YELLOW.withAlpha(0.6),
                    depthFailMaterial: Cesium.Color.YELLOW.withAlpha(0.6),
                }
            }));
        }
        this.entity( 'tb_'+t.id, this.mapService.viewer.entities.add({
            show:false,
            polyline: {
                positions: positions,
                width: 10.0,
                material: Cesium.Color.BLACK.withAlpha(0.6),
                depthFailMaterial: Cesium.Color.BLACK.withAlpha(0.6),
            }
        }));
        positions = this.coordHelper.updateCesiumCartesianHeights(positions, inc, true);
        this.entity( 'tf_'+t.id, this.mapService.viewer.entities.add({
            show: false,
            polyline: {
                positions: positions,
                width: 5.0,
                material: new Cesium.PolylineDashMaterialProperty({
                    color: Cesium.Color.YELLOW,
                }),
                depthFailMaterial: new Cesium.PolylineDashMaterialProperty({
                    color: Cesium.Color.YELLOW.withAlpha(0.7),
                }),
            }
        }));
        if ( this.debug ) { console.log( '##### PERIMETER RENDER', 't_'+t.id, positions ); }
    }

    delete ( t:Transform ) {
        if ( this.items[t.id] ) {
            delete this.items[t.id];
            this.wipeEntity('tb_'+t.id);
            this.wipeEntity('tf_'+t.id);
            // this.wipeEntity('ts_'+t.id);
        }
    }

    end() {
        if ( this.debug ) { console.log ( '##### PERIMETER END' ); }
        this.wipe();
    }

    checkTile ( tid:number, tile:any ) {
        let c = [];
        let t = {
            tid:tid,
            uuid: tile['__uuid'] ? tile['__uuid'] : this.uuidv4('_','_'),
            updated:false,
            pickId:null,
            children:0,
            centerZDepth: null,
            distance: null,
            points: null,
            contentState: null,
            rad: null,
            pos: null,
            changeLog: []
        }
        
        const uuid = t.uuid; // tile['uuid'] ? tile['uuid'] : this.uuidv4();
        const lut = this.tilesets['t_'+tid];

        // console.log('check', tid, uuid, lut[uuid] );

        if ( lut[uuid] ) {
            t = lut[uuid];
            // console.log ( 'found', t );
            t.updated = true;
            c.push('update');
        } else {
            // console.log ( 'NOT found', 't_'+tid, uuid, this.inTheMomentProps(lut), this.inTheMomentProps(lut[uuid]) );
        }

        if ( ! tile.__uuid ) {
            tile.__uuid = uuid;
            c.push('tile.uuid');
        }
        if ( !tile.__tid ) {
            tile.__tid = tid;
            c.push('tile.tid');
        }

        if ( tile.children ) {
            t.children = tile.children.length;
        }
        if ( tile._boundingVolume && tile._boundingVolume._boundingSphere ) {
            t.pos = tile._boundingVolume._boundingSphere.center;
            t.rad = tile._boundingVolume._boundingSphere.radius;
            c.push('bounding');
        }
        if ( tile._centerZDepth ) {
            t.centerZDepth = tile._centerZDepth;
            c.push('center');
        }
        if ( tile._distanceToCamera ) {
            t.distance = tile._distanceToCamera;
            c.push('distance');
        }
        if ( tile._content && tile._content._pickId ) {
            t.pickId = tile._content._pickId.key;
            c.push('pick');
            /* if ( tile._content._pickId._pickObjects && tile._content._pickId._pickObjects[t.pickId] ) {
                if ( tile._content._pickId._pickObjects[t.pickId].content ) { }
            } */
        }
        if ( tile._content && tile._content.pointsLength ) {
            t.points = tile._content.pointsLength;
            c.push('points');
        }
        t.contentState = tile._contentState;

        t.changeLog.push(c);
        this.tilesets['t_'+tid][uuid] = t;

        return t;
    }

    traverseTiles ( tid:number, tile:any = null, ret:any = [], depth:number = 0 ) {

        if ( !tile ) {
            return null;
        }

        let t = this.checkTile(tid, tile);

        ret.push(t);

        if ( tile.children ) {
            tile.children.forEach(t => {
                ret = this.traverseTiles ( tid, t, ret, depth + 1);
            });
        }
    
        return ret;

        
        // if ( tile._boundingVolume && tile._boundingVolume._boundingSphere ) {

            // t.pos = tile._boundingVolume._boundingSphere.center;
            // t.rad = tile._boundingVolume._boundingSphere.radius;

            /* const grid = Math.round(rad / 20);

            this.entity ( 'sphere', this.mapService.viewer.entities.add({
                position: pos,
                ellipsoid: {
                    radii: new Cesium.Cartesian3(rad, rad, rad),
                    fill: false,
                    outline: true,
                    outlineColor: Cesium.Color.WHITE.withAlpha(0.8),
                    slicePartitions: grid,
                    stackPartitions: grid + 5,
                },
            })); */

            // ret.push( tile._boundingVolume._boundingSphere.center );
            // const times = Math.round ( ( 33 / tile._boundingVolume._boundingSphere.radius ) * ( 200 / ( tile._boundingVolume._boundingSphere.radius / 2 ) ) );
            
            /*
            const log = Math.log ( rad );
            const times = 12 - Math.round ( log );
            const size = 7 + Math.round ( ( rad * 1.2 ) / log ); //  - Math.round ( rad / times );

            if ( times > 0 ) {
                const geodetic = new CoordGeodetic(tile._boundingVolume._boundingSphere.center);
                const scatter = this.coordHelper.getBoundingCoords ( geodetic, size, times );
                const cartesians = this.coordHelper.toCartesians(scatter);
                cartesians.forEach( c => ret.push(c) );
                console.log('!', times, size, rad, log );
            } else {
                console.log('!!', times, size, rad, log );
            }
            */
        // }

    }
/*
    createScatterBoundery ( simpleCoords:CoordGeodetic[] = null ) {

        this.originalCoords = simpleCoords;

        let all = [];

        if ( simpleCoords ) {
            simpleCoords.forEach ( latLong => {
                this.coordHelper.getBoundingCoords ( latLong ).forEach ( geo => {
                    if ( geo ) {
                        all.push ( geo );
                    } 
                });
            });
            this.coords = this.coordHelper.createHullPolygon( all );
        }

        if ( this.debug ) { console.log ( '%c bounding.plugin %c createScatterBoundery() from=['+simpleCoords.length+'] scattered=['+all.length+'] boundary=['+this.coords.length+']', this.debugPrimary, this.debugSecondary ); }

    }
  */  
}


